<template>
  <div class="inline-block relative">
    <select v-autoResizeSelect="arrowSize" class="select" @change="onChange">
      <slot></slot>
    </select>
    <div class="arrow">
      <svg
        class="fill-current h-3 w-3"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
      >
        <path
          d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
        />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: "UiInlineSelect",
  props: {
    arrowSize: {
      type: Number,
      default: 13,
    },
  },
  methods: {
    onChange(event) {
      this.$emit("change", event.target?.value);
    },
  },
};
</script>

<style scoped>
.select {
  @apply block appearance-none bg-transparent border-none cursor-pointer;
  color: currentColor;

  &:focus {
    @apply outline-none;
  }
}

.arrow {
  @apply pointer-events-none absolute flex items-center;
  bottom: 0;
  color: currentColor;
  right: -1px;
  top: 0;
}
</style>
